import { useState } from "react";
import { Check, Link2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ShareScenarioButtonProps {
  url: string;
}

export default function ShareScenarioButton({ url }: ShareScenarioButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      // ignore
    }
  };

  return (
    <Button variant="outline" size="sm" onClick={handleCopy} className="gap-1.5">
      {copied ? (
        <>
          <Check className="h-3.5 w-3.5" /> Link copied
        </>
      ) : (
        <>
          <Link2 className="h-3.5 w-3.5" /> Share scenario
        </>
      )}
    </Button>
  );
}
